import { FC, MouseEvent } from 'react';
import { EElementSize } from '../../types';
import { CloseIcon } from '../icons';
import { TagStyled } from './tag.styled';
import { ETagVariant, ITagProps } from './tag.types';

export const Tag: FC<ITagProps> = ({
  children,
  shouldStopClick = true,
  isClearable = true,
  $variant = ETagVariant.PRIMARY,
  $size = EElementSize.S,
  onClose = () => {},
  ...props
}) => {
  const closeHandler = (e: MouseEvent) => {
    shouldStopClick && e.stopPropagation();
    onClose();
  };

  return (
    <TagStyled
      $variant={$variant}
      $size={$size}
      $isClearable={isClearable}
      {...props}
    >
      <span className="inner">{children}</span>
      {isClearable && <CloseIcon className="icon" onClick={closeHandler} />}
    </TagStyled>
  );
};
